import ref from 'vue-ref';
import { antInput } from './antInputDirective';
import { antDecorator } from './FormDecoratorDirective';

export default {
  install: function install(Vue) {
    Vue.use(ref, { name: 'ant-ref' });
    antInput(Vue);
    antDecorator(Vue);
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/es/_util/antDirective.js
// module id = null
// module chunks = 